module.exports = __webpack_public_path__ + "6ad3f669a8ca437259338b9a63a7cb71.pdf";